import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute, Params } from "@angular/router";
import { Technology } from "../../../entity/Technology";
import { TechnologyService } from "../../services/TechnologyService";

@Component({
	selector: "technology-view",
	templateUrl: "./technology.component.html",
	styleUrls: ["./technology.component.scss"],
})
export class TechnologyComponent implements OnInit {

	public technology: Technology;

	private readonly activatedRoute: ActivatedRoute;
	private readonly snackBar: MatSnackBar;
	private readonly technologyService: TechnologyService;

	private constructor(activatedRoute: ActivatedRoute, snackBar: MatSnackBar, technologyService: TechnologyService) {
		this.activatedRoute = activatedRoute;
		this.snackBar = snackBar;
		this.technologyService = technologyService;
	}

	public ngOnInit(): void {
		this.ngOnInitAsync().catch((reason: Error) => {
			console.error(reason);
			this.snackBar.open(reason.name, "Close", {
				duration: 5000,
			});
		});
	}

	private async ngOnInitAsync(): Promise<void> {
		this.activatedRoute.params.subscribe(async (params: Params) => {
			const technologyId: number = parseInt(params.id, 10);
			this.technology = await this.technologyService.getTechnologyComponentAsync(technologyId);
		});
	}

}



// WEBPACK FOOTER //
// ./Frontend/src/app/components/technology/technology.component.ts